export enum EGameConfigs {
  // Econ
  ECONOMY = 'economy',
  ITEMS = 'items',

  // Boosts
  BOOSTS = 'boosts',
  BOOSTS_TF = 'boosts-tf',

  // Bot parts
  BOT_PARTS = 'bot-parts',
  BOT_PARTS_TF = 'bot-parts-tf',

  // Action game skills
  CORE_SKILLS = 'core-skills',
  PART_SKILLS = 'part-skills',

  // Maps — REST / combat-game-maps bundle keys (distinct from analytics `GameModes`).
  // MAPS_OR aligns with Outpost Run / OR. `MAPS_DOMINATION` is the legacy REST key for Zone Rush / capture-mode map lists;
  // When a rename/migration pass allows it, this should become something like `MAPS_ZR`
  // (see Nova authoritative-game-engine README → *Config key naming*).
  MAPS_OR = 'maps-outpostRun',
  MAPS_TF = 'maps-terraform',
  MAPS_DOMINATION = 'maps-domination',

  // Miscellaneous
  NICK_NAMES = 'nick-names',
  /**
   * Represents a group of configs unto itself, of all various types (images, spine atlases, audio, etc.)
   */
  ASSETS = 'assets',
  SWATCH_DATA = 'swatch-data',

  // Groups of others above
  ALL_COMBAT_GAME = 'all-combat-game',
  COMBAT_GAME_MAPS = 'combat-game-maps',
  ALL_TERRAFORMING = 'all-terraforming'
}
